// Views
import ViewMain from '@/views/Main.vue'
// const ViewMain = () => import(/* webpackChunkName: "main" */ '@/views/Main.vue')

// Partials
const PartialHome = () => import(/* webpackChunkName: "main" */ '@/views/partials/Home.vue')
const PartialPage = () => import(/* webpackChunkName: "page" */ '@/views/partials/Page.vue')

// Page Partials - Insights
const InsightsUsTreasury = () => import(/* webpackChunkName: "insights" */ '@/views/partials/insights/UsTreasuryClearing.vue')
const DigitalAssets = () => import(/* webpackChunkName: "insights" */ '@/views/partials/insights/DigitalAssets.vue')
const AcceleratedSettlement = () => import(/* webpackChunkName: "insights" */ '@/views/partials/insights/AcceleratedSettlement.vue')
const AdvancingModernization = () => import(/* webpackChunkName: "insights" */ '@/views/partials/insights/AdvancingModernization.vue')

// Page Partials - Letters
const CEO = () => import(/* webpackChunkName: "letters" */ '@/views/partials/letters/CEO.vue')
const CFO = () => import(/* webpackChunkName: "letters" */ '@/views/partials/letters/CFO.vue')

// Page Partials - Delivering Value
const InsightsNationalSecurities = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/InsightsNationalSecurities.vue')
const ConsultingServices = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/ConsultingServices.vue')
const WealthManagement = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/WealthManagement.vue')
const TradeProcessing = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/TradeProcessing.vue')
const DtccDigitalAssets = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/DtccDigitalAssets.vue')
const DataServices = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/DataServices.vue')
const Repository = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/Repository.vue')
const FixedIncome = () => import(/* webpackChunkName: "value" */ '@/views/partials/value/FixedIncome.vue')

// Routes
export const routes = [
	{
		name: 'main',
		path: '/:filter?',
		component: ViewMain,
		children: [
			{
				name: 'home',
				path: '',
				components: {
					Content: PartialHome,
				},
				children: [
					{
						name: 'page',
						path: 'page',
						components: {
							Page: PartialPage,
						}
					},
					{
						name: 'us-treasury-clearing',
						path: 'insights/us-treasury-clearing',
						components: {
							Page: InsightsUsTreasury,
						}
					},
					{
						name: 'accelerated-settlement',
						path: 'insights/accelerated-settlement',
						components: {
							Page: AcceleratedSettlement,
						}
					},
					{
						name: 'digital-assets',
						path: 'insights/digital-assets',
						components: {
							Page: DigitalAssets,
						}
					},
					{
						name: 'advancing-modernization',
						path: 'insights/advancing-modernization',
						components: {
							Page: AdvancingModernization,
						}
					},
					{
						name: 'national-securities-clearing-corporation',
						path: 'value/national-securities-clearing-corporation',
						components: {
							Page: InsightsNationalSecurities,
						}
					},
					{
						name: 'consulting-services',
						path: 'value/consulting-services',
						components: {
							Page: ConsultingServices,
						}
					},
					{
						name: 'wealth-management',
						path: 'value/wealth-management',
						components: {
							Page: WealthManagement,
						}
					},
					{
						name: 'trade-processing',
						path: 'value/trade-processing',
						components: {
							Page: TradeProcessing,
						}
					},
					{
						name: 'dtcc-digital-assets',
						path: 'value/dtcc-digital-assets',
						components: {
							Page: DtccDigitalAssets,
						}
					},
					{
						name: 'data-services',
						path: 'value/data-services',
						components: {
							Page: DataServices,
						}
					},
					{
						name: 'repository',
						path: 'value/repository',
						components: {
							Page: Repository,
						}
					},
					{
						name: 'fixed-income',
						path: 'value/fixed-income',
						components: {
							Page: FixedIncome,
						}
					},
					{
						name: 'ceo',
						path: 'letters/ceo',
						components: {
							Page: CEO,
						}
					},
					{
						name: 'cfo',
						path: 'letters/cfo',
						components: {
							Page: CFO,
						}
					},
				]
			},
			// {
			// 	name: 'page',
			// 	path: 'page/page',
			// 	components: {
			// 		Content: PartialHome,
			// 		Page: PartialPage,
			// 	},
			// },
		]
	}
]
